import React, {Component} from "react";
import '../node_modules/bootstrap/dist/css/bootstrap.min.css';
import './styles/index.css';

import Login from "./components/Login";
import { BrowserRouter as Router, Switch, Route} from "react-router-dom";

const LOGIN_PATH='/login';

class  PassurLogin extends Component{
 
    render(){
        return (
        <Router basename= {LOGIN_PATH}>
          <Switch>
            <Route path='/' component={Login} />
          </Switch>
        </Router>
          );
    }
}

export default PassurLogin;
